import {z} from "zod";

import {loginSchema} from "../schemas";
import {LoginRequest} from "../types";

class AuthSerializer {
  serializeLogin(data: z.infer<typeof loginSchema>): LoginRequest {
    return {
      ...data,
      remember_me: data.remember_me ? 1 : 0,
    };
  }
  serializeToken(token: string): LoginRequest {
    return {
      token,
      remember_me: 0,
    };
  }
}

export const authSerializer = new AuthSerializer();
